<template>
    <div
      style="margin: 30px auto;background-color: rgba(41, 155, 255, .1);width: 96%;overflow-y:auto;height: 53vh;padding-top: 20px;">
      <!--<span style="margin-left: 20px;">画面布局：</span>
      <el-select
          @change="change"
          size="mini"
          style="width: 80px;"
          v-model="channel">
        <el-option
            :key="item.id"
            :label="item.name"
            :value="item.id"
            v-for="item in channelList">
        </el-option>
      </el-select>-->
      <ul class="videoUl">
        <li class="videoLi one">
          <video-component :channel="1" :device-info="deviceInfo"
                           :properties="portProperties"></video-component>
        </li>
      </ul>
    </div>
</template>

<script>
import VideoComponent from "@/components/video/VideoComponent";
import {getDeviceInfo} from "@/network/device-info";

export default {
  name: "Video",
  components: {VideoComponent},
  props: ['deviceInfo'],
  mounted() {
    this.getDeviceInfo();
  },
  data() {
    return {
      portProperties: null,
      channel: "1",
      channelList: [{
        id: "1",
        name: "1x1",
      }, {
        id: "4",
        name: "2x2",
      }, {
        id: "9",
        name: "3x3",
      }, {
        id: "16",
        name: "4x4",
      }, {
        id: "25",
        name: "5x5",
      }, {
        id: "36",
        name: "6x6",
      }],
      channels: [0],
    }
  },
  methods: {
    getDeviceInfo() {
      getDeviceInfo(this.deviceInfo.id).then(res => {
        if (res.code === 0) {
          this.portProperties = JSON.parse(res.data.portProperties)
        }
      })
    },
    change(id) {
      this.channels = []
      for (let i = 0; i < id; i++) {
        this.channels.push(i)
      }
      console.log(this.channels);
    }
  }
}
</script>

<style scoped>
.videoUl {
  width: 70%;
  /*height: 91%;*/
  margin: auto;
  padding-left: 0;
}

.videoLi {
  float: left;
  list-style: none;
  border: 1px solid #fff;
}

.one {
  width: 100%;
  height: 100%;
}

.two {
  width: 50%;
  height: 50%;
}

.three {
  width: 33.3%;
  height: 33.3%;
}

.four {
  width: 25%;
  height: 25%;
}
</style>
